import { render, staticRenderFns } from "./pumpkinWrap-halloween.vue?vue&type=template&id=5e0402ef"
import script from "./pumpkinWrap-halloween.vue?vue&type=script&lang=js"
export * from "./pumpkinWrap-halloween.vue?vue&type=script&lang=js"
import style0 from "./pumpkinWrap-halloween.vue?vue&type=style&index=0&id=5e0402ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports